import { Component, OnInit } from '@angular/core';
import { AmChartsService, AmChart } from "@amcharts/amcharts3-angular";
import * as $ from "jquery";
import { CommonService } from 'src/app/Services/common.service';
import { DevdashboardService } from 'src/app/Services/devdashboard.service';
import { NgForm } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { DevDashboard, DevDashboardDet } from 'src/app/Models/DevDashboard';
import * as CryptoJS from 'crypto-js';
import { IMG_ROOT_URL, ROOT_URL } from 'src/app/Models/Config';
import { EmployeeService } from 'src/app/Services/employee.service';

@Component({
  selector: 'app-developers-home-screen',
  templateUrl: './developers-home-screen.component.html',
  styleUrls: ['./developers-home-screen.component.css']
})
export class DevelopersHomeScreenComponent implements OnInit {

  private chartdiv: AmChart;
  private chartdiv2: AmChart;
  private chartdiv3: AmChart;
  Remark: string = '';
  Description: string = '';
  FileList: string[] = [];
  jobOrderForm: boolean;
  CustomerRequirementForm: boolean
  WarningModel: boolean;

  constructor(private AmCharts: AmChartsService,
              private toastr: ToastrService,
              public _DevdashboardService: DevdashboardService,
              public commonService:CommonService           
  ) { }
  
  ngOnInit(): void {
    this.Description = ''
    this.Remark = ''
    this.FileList = []
    this._DevdashboardService.AllPendingWorkDet = {
      CompDate: null,
      FileList: [],
      Module: null,
      ModuleId: null,
      Particular: null,
      ParticularId: null,
      StDate: null
    }
    // this.employeeService.employeeDashBoard={
    //   IsEnteredLastJobCard:true,
    //   LastEnteredJobCard:null,
    // }
    this.LoadChart();
    // this.employeeService.displayEmployeeDashBoard('EMPDASHBOARD');
    this.getPendingWorksHeader();  
    this.commonService.storeloginUserId();  
  }

  getPendingWorksHeader() {
    this._DevdashboardService.getPendingWorks().subscribe(obj => {
      this._DevdashboardService.AllPendingWork = obj
    })
  }

  getPendingWorksDet(obj: DevDashboard) {
    this.Description = obj.Description;
    this.Remark = obj.Remark;
    this._DevdashboardService.fetchProjectDet(obj).subscribe(res => {
      this._DevdashboardService.AllPendingWorkDet = res;
      this._DevdashboardService.AllPendingWorkDet.StDate = obj.ExpStDate
      this.FileList = res.FileList;
    });
  }

  downloadFileUrl(URL) {
    window.open(IMG_ROOT_URL + 'Images/CustomerLogo/' + URL, '_blank');
  }

  LoadChart() {
    // chartdiv2
    var chart = this.AmCharts.makeChart("chartdiv2", {
      "type": "serial",
      "theme": "none",
      "dataProvider": [{
        "month": "Jan",
        "visits": 9
      }, {
        "month": "Feb",
        "visits": 10
      }, {
        "month": "Mar",
        "visits": 11
      }, {
        "month": "April",
        "visits": 12
      }, {
        "month": "May",
        "visits": 13
      }, {
        "month": "June",
        "visits": 14
      }, {
        "month": "July",
        "visits": 15
      }, {
        "month": "Aug",
        "visits": 16
      }, {
        "month": "Sept",
        "visits": 17
      }, {
        "month": "Oct",
        "visits": 18
      }, {
        "month": "Nov",
        "visits": 19
      }, {
        "month": "Dec",
        "visits": 20
      }],
      "valueAxes": [{
        "gridColor": "#FFFFFF",
        "gridAlpha": 0.2,
        "dashLength": 0
      }],
      "gridAboveGraphs": true,
      "startDuration": 1,
      "graphs": [{
        "balloonText": "[[category]]: <b>[[value]]</b>",
        "fillAlphas": 0.8,
        "lineAlpha": 0.2,
        "type": "column",
        "valueField": "visits"
      }],
      "chartCursor": {
        "categoryBalloonEnabled": false,
        "cursorAlpha": 0,
        "zoomable": false
      },
      "categoryField": "month",
      "categoryAxis": {
        "gridPosition": "start",
        "gridAlpha": 0,
        "tickPosition": "start",
        "tickLength": 20
      },
      "export": {
        "enabled": true
      }

    });
    // chartdiv3
    var chart = this.AmCharts.makeChart("chartdiv3", {
      "theme": "none",
      "type": "gauge",
      "axes": [{
        "topTextFontSize": 20,
        "topTextYOffset": 70,
        "axisColor": "#31d6ea",
        "axisThickness": 1,
        "endValue": 100,
        "gridInside": true,
        "inside": true,
        "radius": "50%",
        "valueInterval": 10,
        "tickColor": "#67b7dc",
        "startAngle": -90,
        "endAngle": 90,
        "unit": "%",
        "bandOutlineAlpha": 0,
        "bands": [{
          "color": "#0080ff",
          "endValue": 100,
          "innerRadius": "105%",
          "radius": "170%",
          "gradientRatio": [0.5, 0, -0.5],
          "startValue": 0
        }, {
          "color": "#3cd3a3",
          "endValue": 0,
          "innerRadius": "105%",
          "radius": "170%",
          "gradientRatio": [0.5, 0, -0.5],
          "startValue": 0
        }]
      }],
      "arrows": [{
        "alpha": 1,
        "innerRadius": "35%",
        "nailRadius": 0,
        "radius": "170%"
      }]
    });

    setInterval(randomValue, 2000);

    // set random value
    function randomValue() {
      var value = Math.round(Math.random() * 100);
      chart.arrows[0].setValue(value);
      chart.axes[0].setTopText(value + " %");
      // adjust darker band to new value
      chart.axes[0].bands[1].setEndValue(value);
    }
    function removeUpload() {
      $('.file-upload-input').replaceWith($('.file-upload-input').clone());
      $('.file-upload-content').hide();
      $('.image-upload-wrap').show();
    }
    $('.image-upload-wrap').bind('dragover', function () {
      $('.image-upload-wrap').addClass('image-dropping');
    });
    $('.image-upload-wrap').bind('dragleave', function () {
      $('.image-upload-wrap').removeClass('image-dropping');
    });
    // file upload end
  }

  OnClickAllot(obj: DevDashboardDet) {
    $('#myModalConfirm').css("display", "block")
    this.jobOrderForm = true
    this.CustomerRequirementForm = false
  }

  OnClickCancel() {
    $('#myModalConfirm').css("display", "none")
    $('#myModal').addClass("show");
    this.WarningModel = false
    this.jobOrderForm = false
  }

  OnClickAllotNote(obj: DevDashboardDet) {
    $('#myModalConfirm1').css("display", "block")
    this.jobOrderForm = false
    this.CustomerRequirementForm = true
  }

  OnClickCancelcus() {
    $('#myModalConfirm1').css("display", "none")
    $('#myModal').addClass("show");
    this.WarningModel = false
    this.jobOrderForm = false
  }

}
